import { initializeApp } from "firebase/app";
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getVertexAI } from "firebase/vertexai";

const firebaseConfig = {
  apiKey: "AIzaSyA8-IxXsAmYEYrbdrt8IH_A-KLKEn5hwkg",
  authDomain: "clinica-de-la-costa.firebaseapp.com",
  projectId: "clinica-de-la-costa",
  storageBucket: "clinica-de-la-costa.appspot.com",
  messagingSenderId: "785937294926",
  appId: "1:785937294926:web:e08a0f5308dee8f8c4051f",
  measurementId: "G-GYMV26QCCB"
};

// Inicializa Firebase solo una vez
const app = initializeApp(firebaseConfig);

// Inicializa los servicios que necesites
const db = getFirestore(app);
const storage = getStorage(app);
const vertexAI = getVertexAI(app); // Solo si vas a usar Vertex AI

// Exporta los servicios que necesites en otros archivos
export { db, storage, vertexAI, firebaseConfig, app };